import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Pill, Bone, Droplet, Home } from 'lucide-react';
const solutions = [{
  icon: Pill,
  title: 'Corticoides y pastillas',
  description: 'Bloquean la señal de picor en el cerebro pero no apagan el "incendio" interno, desgastando sus órganos a largo plazo.'
}, {
  icon: Bone,
  title: 'Croquetas "hipoalergénicas"',
  description: 'Industriales siguen conteniendo conservantes y carbohidratos que alimentan los hongos y las levaduras en su piel.'
}, {
  icon: Droplet,
  title: 'Champús medicados',
  description: 'Suelen ser demasiado agresivos, destruyendo la barrera protectora natural de la piel y empeorando el brote días después.'
}, {
  icon: Home,
  title: 'Ignorar gatillos ambientales',
  description: 'En tu casa hace que el perro se re-contamine cada vez que vuelve de su paseo.'
}];
export function FailedSolutions() {
  return <section className="py-24 bg-white" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-27">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-lg text-charcoal-400" data-id="element-28">
            Las soluciones convencionales solo ponen una curita sobre un
            problema profundo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-29">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-50 p-8 rounded-2xl border border-cream-200 relative overflow-hidden group hover:border-rust-200 transition-colors" data-id="element-30">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-31">
                <XCircle size={120} className="text-rust" data-id="element-32" />
              </div>

              <div className="relative z-10" data-id="element-33">
                <div className="w-12 h-12 bg-rust/10 rounded-xl flex items-center justify-center text-rust mb-6" data-id="element-34">
                  <solution.icon size={24} data-id="element-35" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-36">
                  {solution.title}
                </h3>
                <p className="text-charcoal-500 leading-relaxed" data-id="element-37">
                  {solution.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}